import styled from "styled-components";

export const StyledPersonTile = styled.div`

@import "src/_variables";
  display: flex;
  flex-direction: column;
  width: 296px;
  border-radius: 20px;
  border: 1px solid ${({theme}) => theme.colors.product};
  overflow: hidden;
  position: relative;
  background-color: transparent;

  .person-tile__image {
    width: 294px;
    height: 213px;
    overflow: hidden;

    img {
      width: 100%;
    }
  }

  .person-tile__content {
    height: 100%;
  }
}

.image {
  box-shadow: none;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;

  img {
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    object-fit: cover;
  }
}

.person-tile__info {
  padding: 20px 24px 24px 24px;
  display: flex;
  flex-direction: column;
}

.person-tile__name {
  color: ${({theme}) => theme.colors.emerald};
  font-size: 1.625rem;
  line-height: 2.375rem;
  font-family: ${({theme}) => theme.fonts.primary};
  margin-bottom: 4px;
}

.person-tile__title {
  font-size: .875rem;
  line-height: 1.375rem;
  color: ${({theme}) => theme.colors.night};
  margin-bottom: 20px;
}

.person-tile__footer {
  a {
    font-weight: ${({theme}) => theme.fonts.weight.bold};
    color: ${({theme}) => theme.colors.raspberry};
    line-height: 1.5rem;

    svg {
      margin-left: 10px;
    }
  }
}

`;
